export const MINUTES_PER_DAY = 1440;
/** Game time in ms since the world epoch at real time `nowMs`. */
export function worldTimeAt(sync, nowMs) {
    return sync.worldTime + (nowMs - sync.serverNow) * sync.timeScale;
}
/** Game minutes since the epoch. */
export function worldMinutes(sync, nowMs) {
    return worldTimeAt(sync, nowMs) / 60000;
}
/** Whole game days since the epoch (day 0 = the first day). */
export function worldDay(worldTimeMs) {
    return Math.floor(worldTimeMs / (MINUTES_PER_DAY * 60000));
}
/** Minutes into the current game day, 0..1440. */
export function dayMinutes(worldTimeMs) {
    const m = worldTimeMs / 60000;
    return ((m % MINUTES_PER_DAY) + MINUTES_PER_DAY) % MINUTES_PER_DAY;
}
/** Sunrise / sunset in game minutes of the day (prototype values: 6:30 and 19:15). */
export const SUNRISE_MIN = 6.5 * 60;
export const SUNSET_MIN = 19.25 * 60;
/**
 * Sun phase angle for a minute of day (prototype sky.js `sunPhase`):
 * 0..π across daylight, π..2π across the night.
 */
export function sunPhase(minutes) {
    if (minutes >= SUNRISE_MIN && minutes <= SUNSET_MIN) {
        return (Math.PI * (minutes - SUNRISE_MIN)) / (SUNSET_MIN - SUNRISE_MIN);
    }
    const nightLen = MINUTES_PER_DAY - (SUNSET_MIN - SUNRISE_MIN);
    const t = minutes > SUNSET_MIN ? minutes - SUNSET_MIN : minutes + MINUTES_PER_DAY - SUNSET_MIN;
    return Math.PI + (Math.PI * t) / nightLen;
}
/**
 * Unit sun direction for a minute of day (SimPure.sunDirection).
 * P0 keeps the prototype's tilt-free path; `dayOfYear` is accepted for the
 * seasonal tilt that lands with weather polish (P7) and folded in at zero
 * amplitude so the API is stable across phases. Returns [x, y, z], y = elevation sine.
 */
export function sunDirection(minutes, dayOfYear = 0) {
    const ph = sunPhase(minutes);
    const tilt = Math.sin((dayOfYear / 365) * Math.PI * 2) * 0; // explicit zero: no seasonal effect yet
    const x = Math.cos(ph);
    const y = Math.sin(ph) * 0.93 + tilt;
    const z = -0.36;
    const inv = 1 / Math.hypot(x, y, z);
    return [x * inv, y * inv, z * inv];
}
